var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 32.9691,
    height: 34.1608,
    rx: 16.4846,
    stroke: "white",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9774 26.9608H8.29351V14.3016H11.9774V26.9608ZM10.1335 12.5748C8.95549 12.5748 8 11.5336 8 10.2766C8 9.67282 8.22478 9.09375 8.62488 8.6668C9.02499 8.23986 9.56765 8 10.1335 8C10.6993 8 11.242 8.23986 11.6421 8.6668C12.0422 9.09375 12.267 9.67282 12.267 10.2766C12.267 11.5336 11.3111 12.5748 10.1335 12.5748ZM25.7652 26.9608H22.0892V20.7984C22.0892 19.3297 22.0614 17.4463 20.1738 17.4463C18.2585 17.4463 17.965 19.0419 17.965 20.6926V26.9608H14.285V14.3016H17.8182V16.0285H17.8698C18.3616 15.0338 19.563 13.9842 21.3554 13.9842C25.0838 13.9842 25.7691 16.6041 25.7691 20.0069V26.9608H25.7652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.425e9d48dc44712dc1260a3251c47201.svg";
export { ForwardRef as ReactComponent };